
export default {
    // eslint-disable-next-line no-useless-escape
    email: (email) => /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/.test(email),
    date: (date) => /([0-9]{4})-([0-9]{2})-([0-9]{2})/.test(date),
    phone: (phone) => /^\+(?:[\d]{2,})$/.test(phone),
    bankAccount: (bankAccount) => /^(\d+){16,}/.test(bankAccount),
    radio: (value) => value !== '',
}
